var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"super-button",class:[_vm.variant,{ 'disabled':_vm.disabled}],attrs:{"role":"link","disabled":_vm.disabled,"aria-label":_vm.text},on:{"click":_vm.openLink}},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }